import React, { useState } from 'react'
import { IconAlertCircle } from '@tabler/icons-react'
import { ActionSheet } from 'antd-mobile'
import type { Action } from 'antd-mobile/es/components/action-sheet'

interface ComplaintButtonProps {
  className?: string
}

const ComplaintButton: React.FC<ComplaintButtonProps> = ({ className = '' }) => {
  const [isHovered, setIsHovered] = useState(false)
  const [actionSheetVisible, setActionSheetVisible] = useState(false)

  const actions: Action[] = [
    {
      text: '在线客服',
      key: 'online',
      onClick: () => {
        window.open('https://chat.yuexiangcha.com/chatlink.html', '_blank')
      },
    },
    {
      text: '电话客服 (400-079-9168)',
      key: 'phone',
      onClick: () => {
        window.location.href = 'tel:4000799168'
      },
    },
  ]

  const handleComplaintClick = () => {
    setActionSheetVisible(true)
  }

  const backgroundColor = isHovered ? '#D97706' : '#F59E0B'

  return (
    <>
      <div
        className={`flex flex-col items-center justify-center cursor-pointer p-3 transition-all duration-300 hover:scale-105 ${className || ''}`}
        onClick={handleComplaintClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ backgroundColor }}
      >
        <IconAlertCircle size={26} color="#FFFFFF" />
        <span className="text-xs font-medium mt-1" style={{ color: '#FFFFFF' }}>
          联系客服
        </span>
      </div>
      <ActionSheet
        visible={actionSheetVisible}
        actions={actions}
        onClose={() => setActionSheetVisible(false)}
        cancelText="取消"
      />
    </>
  )
}

export default ComplaintButton
